var React = require('react');

function IconCloseCircleO (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M957.7 517.5c0-245.8-199.2-445-445-445s-445 199.2-445 445 199.2 445 445 445 445-199.2 445-445zm-826 0c0-210.4 170.6-381 381-381s381 170.6 381 381-170.6 381-381 381-381-170.6-381-381z","key":0}),React.createElement("path",{"d":"M687.2 733.1L513.7 559.7 340.3 733.1c-3.9 3.9-10.2 3.9-14.1 0L294.1 701c-3.9-3.9-3.9-10.2 0-14.1l173.5-173.4-173.5-173.4c-3.9-3.9-3.9-10.2 0-14.1l32.1-32.1c3.9-3.9 10.2-3.9 14.1 0l173.4 173.4 173.5-173.4c3.9-3.9 10.2-3.9 14.1 0l32.1 32.1c3.9 3.9 3.9 10.2 0 14.1L559.9 513.5l173.5 173.4c3.9 3.9 3.9 10.2 0 14.1l-32.1 32.1c-3.8 3.9-10.2 3.9-14.1 0z","key":1})]);
}

IconCloseCircleO.displayName = "IconCloseCircleO";

IconCloseCircleO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconCloseCircleO;

IconCloseCircleO.default = IconCloseCircleO;
